import $ from "jquery";
// JS
import './js/main.js'
//FA
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'


// SCSS
import './assets/scss/main.scss'
// import 'bootstrap';
